import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft, Download, Filter, Calendar } from 'lucide-react';
import UserAnalytics from '../components/analytics/UserAnalytics';
import DeviceAnalytics from '../components/analytics/DeviceAnalytics';
import AdherenceAnalytics from '../components/analytics/AdherenceAnalytics';
import AlertsAnalytics from '../components/analytics/AlertsAnalytics';
import DosesAnalytics from '../components/analytics/DosesAnalytics';
import ActivityAnalytics from '../components/analytics/ActivityAnalytics';
import TreatmentAnalytics from '../components/analytics/TreatmentAnalytics';
import ComplianceAnalytics from '../components/analytics/ComplianceAnalytics';
import CriticalAnalytics from '../components/analytics/CriticalAnalytics';
import './Analytics.css';

const Analytics = () => {
  const { type } = useParams();
  const navigate = useNavigate();

  const analyticsConfig = {
    users: {
      title: 'User Analytics',
      subtitle: 'Detailed patient management and statistics',
      component: UserAnalytics
    },
    devices: {
      title: 'Device Status Analytics',
      subtitle: 'Real-time device connectivity and performance',
      component: DeviceAnalytics
    },
    adherence: {
      title: 'Adherence Analytics',
      subtitle: 'Comprehensive medication adherence tracking',
      component: AdherenceAnalytics
    },
    alerts: {
      title: 'Active Alerts Analytics',
      subtitle: 'Alert management and resolution tracking',
      component: AlertsAnalytics
    },
    doses: {
      title: 'Daily Doses Analytics',
      subtitle: 'Medication dosing patterns and compliance',
      component: DosesAnalytics
    },
    activity: {
      title: 'Recent Activity Analytics',
      subtitle: 'Patient interaction and engagement metrics',
      component: ActivityAnalytics
    },
    treatment: {
      title: 'Treatment Progress Analytics',
      subtitle: 'Long-term treatment outcomes and trends',
      component: TreatmentAnalytics
    },
    compliance: {
      title: 'Compliance Analytics',
      subtitle: 'Weekly and monthly compliance trends',
      component: ComplianceAnalytics
    },
    critical: {
      title: 'Critical Patients Analytics',
      subtitle: 'High-risk patient monitoring and intervention',
      component: CriticalAnalytics
    }
  };

  const config = analyticsConfig[type] || analyticsConfig.users;
  const AnalyticsComponent = config.component;

  const handleBack = () => {
    navigate('/overview');
  };

  return (
    <div className="analytics-page">
      <div className="analytics-header">
        <div className="header-top">
          <button className="back-button" onClick={handleBack}>
            <ArrowLeft size={20} />
            Back to Overview
          </button>
          
          <div className="header-actions">
            <button className="action-btn secondary">
              <Filter size={16} />
              Filters
            </button>
            <button className="action-btn secondary">
              <Calendar size={16} />
              Date Range
            </button>
            <button className="action-btn primary">
              <Download size={16} />
              Export Data
            </button>
          </div>
        </div>
        
        <div className="header-content">
          <h1>{config.title}</h1>
          <p>{config.subtitle}</p>
        </div>
      </div>

      <div className="analytics-content">
        <AnalyticsComponent />
      </div>
    </div>
  );
};

export default Analytics;



